import React from 'react';
import { Clock, Mail } from 'lucide-react';

const DemoExpired = () => {
  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center px-4">
      <div className="max-w-2xl w-full">
        <div className="bg-gray-800 rounded-lg shadow-xl p-8 text-center">
          {/* Icon */}
          <div className="mx-auto h-16 w-16 bg-yellow-500/20 rounded-full flex items-center justify-center mb-6">
            <Clock className="h-8 w-8 text-yellow-500" />
          </div>

          {/* Heading */}
          <h1 className="text-3xl font-bold text-white mb-4">
            Demo-perioden er utløpt
          </h1>

          {/* Message */}
          <p className="text-gray-300 text-lg mb-6">
            Takk for at du har testet Aktivlogg! Din 30-dagers gratis demo er nå over.
          </p>

          <p className="text-gray-400 mb-8">
            Vi håper du har fått et godt inntrykk av hvordan Aktivlogg kan hjelpe din klubb med digital treningslogging.
          </p>

          {/* Call to Action */}
          <div className="bg-gray-700/50 rounded-lg p-6 mb-6">
            <h2 className="text-xl font-semibold text-white mb-3">
              Fortsett med Aktivlogg
            </h2>
            <p className="text-gray-300 mb-4">
              Bestill et abonnement og få tilgang til alle funksjoner igjen.
            </p>
            <a
              href="https://aktivlogg.no/bestill"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block px-8 py-3 bg-yellow-500 text-gray-900 font-semibold rounded-lg hover:bg-yellow-400 transition-colors"
            >
              Bestill abonnement
            </a>
          </div>

          {/* Contact Information */}
          <div className="border-t border-gray-700 pt-6">
            <div className="flex items-center justify-center text-gray-400">
              <Mail className="h-5 w-5 mr-2" />
              <span>Spørsmål? Kontakt oss på </span>
              <a 
                href="mailto:yngve@aktivlogg.no" 
                className="text-yellow-500 hover:text-yellow-400 ml-1"
              >
                yngve@aktivlogg.no
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DemoExpired;
